export default __webpack_public_path__ + "static/media/Captain's Boots of the Golden Sun.7711fbf8.jpg";